module.exports = require("./hy-AM");